import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSurgeon } from '../components/AboutSurgeon';
import { OperatedFather } from '../components/OperatedFather';
import { TreatmentTimeline } from '../components/TreatmentTimeline';
import { ComingToSpb } from '../components/ComingToSpb';
import { WhoThisIsFor } from '../components/WhoThisIsFor';
import { FinalCtaForm } from '../components/FinalCtaForm';
import { StickyMobileCta } from '../components/StickyMobileCta';
export function LandingPage() {
  return <div className="min-h-full w-full bg-white font-heading text-slate-900" data-id="element-120">
      <main className="pb-24 lg:pb-0" data-id="element-121">
        <h1 className="sr-only" data-id="element-122">
          Эндопротезирование коленного и тазобедренного суставов в
          Санкт-Петербурге — хирург-ортопед Павел Иванов
        </h1>
        <HeroSection data-id="element-123" />
        <AboutSurgeon data-id="element-124" />
        <OperatedFather data-id="element-125" />
        <TreatmentTimeline data-id="element-126" />
        <ComingToSpb data-id="element-127" />
        <WhoThisIsFor data-id="element-128" />
        <FinalCtaForm data-id="element-129" />
      </main>
      <footer className="w-full border-t border-slate-100 bg-white pb-24 pt-8 lg:pb-8" data-id="element-130">
        <p className="px-5 text-center text-base text-slate-400" data-id="element-131">
          © Павел Петрович Иванов · Хирург-ортопед · НМИЦ ТО им. Р.Р. Вредена
          г. Санкт-Петербург, ул. Академика Байкова, д. 8
        </p>
      </footer>
      <StickyMobileCta data-id="element-132" />
    </div>;
}